export default "__VITE_ASSET__BhPPTV_P__"